// extracted by mini-css-extract-plugin
module.exports = {"claimRow":"ClaimVoxelRow_claimRow_1QqX5","voxImg":"ClaimVoxelRow_voxImg_C9i5m"};